import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import Icon from '../../common/icons/Icon';

const TIME_ZONE_ID = 'America/Phoenix';

class FollowUpListItem extends Component {
  static propTypes = {
    session: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    onClickItem: PropTypes.func.isRequired,
  };

  getStandardDate = date => {
    const baseDate = moment(date).tz(TIME_ZONE_ID);
    return moment()
      .tz(TIME_ZONE_ID)
      .isSame(baseDate, 'day')
      ? `Today ${baseDate.format('h:mmA')}`
      : baseDate.format('MMM D h:mmA');
  };

  getDisplayDate = (session, type) => {
    switch (type) {
      case 'new':
        const expirationDate = moment(session.submitted_at)
          .tz(TIME_ZONE_ID)
          .add(5, 'days');
        return `Expire${expirationDate.isAfter() ? 's' : 'd'} ${expirationDate.fromNow()}`;
      case 'history':
        if (session.accepted_session_date) {
          return this.getStandardDate(session.accepted_session_date);
        } else {
          return 'No date selected';
        }
      default:
        return this.getStandardDate(session.accepted_session_date);
    }
  };

  handleItemClick = () => {
    const { session, onClickItem } = this.props;
    onClickItem(session);
  };

  render = () => {
    const { session, type } = this.props;

    const displayDate = this.getDisplayDate(session, type);
    const statusClass = `session-list__item-status${type === 'new' ? ' session-list__item-status--new' : ''}`;

    return (
      <div className="session-list__item">
        <Icon icon="Arrow" />
        <div onClick={this.handleItemClick} className="session-list__item__content">
          <span className={statusClass}>
            <span className="display-date">
              {session.status === 'rejected' ? <span className="rejected">Rejected</span> : displayDate}
            </span>
          </span>
          <div className="session-list__item-status--name-type">
            <Icon icon={session.type === 'online' ? 'Computer' : 'People'} />
            {session.user.name}
          </div>
        </div>
      </div>
    );
  };
}

export default FollowUpListItem;



// WEBPACK FOOTER //
// ./src/follow-ups/common/FollowUpListItem.js